// importing actions
import {START_FETCH_STUDENT_TIMELINE, SUCCESS_FETCH_STUDENT_TIMELINE, FAILED_FETCH_STUDENT_TIMELINE, RESET_TIMELINE_CACHE} from './actions/getStudentTimeline';
import {START_CREATE_TIMELINE_TASK, SUCCESS_CREATE_TIMELINE_TASK, FAILED_CREATE_TIMELINE_TASK} from './actions/createTimelineTask';
import {START_UPDATE_TIMELINE_TASK, SUCCESS_UPDATE_TIMELINE_TASK, FAILED_UPDATE_TIMELINE_TASK} from './actions/updateTimelineTask'
import {START_DELETE_TIMELINE_TASK} from './actions/deleteTimelineTask'
import {START_FETCH_STUDENT_TIMELINE_YEAR, SUCCESS_FETCH_STUDENT_TIMELINE_YEAR, FAILED_FETCH_STUDENT_TIMELINE_YEAR} from './actions/getStudentTimelineYear';


import locale from '../locale'


const initState = {
  list: [],
  fetching: false,

}

export default function timelineReducer(state = initState, action){
  switch(action.type){

    // fetching timeline
    case START_FETCH_STUDENT_TIMELINE: {
      return {...state, fetching: true}
    }
    case SUCCESS_FETCH_STUDENT_TIMELINE: {
      return {
        ...state,
        fetching: action.payload.fetching,
        list: action.payload.result_list,
        pagination: {
          itemsCountPerPage: action.payload.amount_per_page,
          activePage: action.payload.current_page_number,
          totalItemsCount: action.payload.total_task_amount,
        }
      }
    }

    case FAILED_FETCH_STUDENT_TIMELINE: {
      return {...state, err: action.payload}
    }

    // fetching timeline year
    case RESET_TIMELINE_CACHE: {
      return { 
        ...initState
      }
    }
    case START_FETCH_STUDENT_TIMELINE_YEAR: {
      return {...state, fetching: true}
    }
    case SUCCESS_FETCH_STUDENT_TIMELINE_YEAR: {
      let years = action.payload.years.unshift(1)
      return {
        ...state,
        year_list: action.payload.years,
      }
    }

    case FAILED_FETCH_STUDENT_TIMELINE_YEAR: {
      return {...state, err: action.payload}
    }

    // formWorking
    case START_CREATE_TIMELINE_TASK: {
      const {
        formWorking
      } = action.payload;

      return {
        ...state,
        formWorking,
      }
    }

    case SUCCESS_CREATE_TIMELINE_TASK: {
      const {
        formWorking
      } = action.payload;

      return {
        ...state,
        formWorking,
      }
    }

    case FAILED_CREATE_TIMELINE_TASK: {
      const {
        err
      } = action.payload;

      return {
        ...state,
      }
    }

    // updating
    case START_UPDATE_TIMELINE_TASK: {
      const {
        index, 
        formWorking,
        taskInfo,
        type,
      } = action.payload;

      const list = state.list.map((existing, i)=>{
        return index === i ? { ...existing, ...taskInfo } : existing;
      })

      if(type == 'pending' || type == 'completed'){
       return {
          ...state,
          list: [
            ...state.list.slice(0, index),
            ...state.list.slice(index + 1)
          ]
        }
      } else {
        return {
          ...state,
          formWorking,
          list,
        }

      }

    }
    
    case SUCCESS_UPDATE_TIMELINE_TASK: {
      const {
        formWorking,
      } = action.payload;

      return {
        ...state,
        formWorking,
      }
    }
    
    case FAILED_UPDATE_TIMELINE_TASK: {
      const {
        formWorking,
      } = action.payload;

      return {
        ...state,
        formWorking,
      }

    }

    // deleting
    case START_DELETE_TIMELINE_TASK: {
      const { index } = action.payload;

      return {
        ...state,
        list: [
          ...state.list.slice(0, index),
          ...state.list.slice(index + 1)
        ]
      }
    }


    default: return {...state}
  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/Timeline/redux/reducer.js